import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import { SiteConfigProvider } from "@/context/SiteConfigContext";
import { LanguageProvider } from "@/context/LanguageContext";
import { Toaster } from "@/components/ui/sonner";
import SiteLayout from "@/components/site/SiteLayout";
import CookieBanner from "@/components/site/CookieBanner";
import Home from "@/pages/Home";
import Library from "@/pages/Library";
import CourseDetail from "@/pages/CourseDetail";
import JournalIndex from "@/pages/JournalIndex";
import JournalDetail from "@/pages/JournalDetail";
import PortfolioIndex from "@/pages/PortfolioIndex";
import PortfolioDetail from "@/pages/PortfolioDetail";
import About from "@/pages/About";
import Services from "@/pages/Services";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  return (
    <MotionConfig reducedMotion="user">
      <SiteConfigProvider>
        <LanguageProvider>
          <BrowserRouter>
            <Routes>
              <Route element={<SiteLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/library" element={<Library />} />
                <Route path="/library/:slug" element={<CourseDetail />} />
                <Route path="/journal" element={<JournalIndex />} />
                <Route path="/journal/:slug" element={<JournalDetail />} />
                <Route path="/portfolio" element={<PortfolioIndex />} />
                <Route path="/portfolio/:slug" element={<PortfolioDetail />} />
                <Route path="/about" element={<About />} />
                <Route path="/services" element={<Services />} />
              </Route>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="bottom-right" />
          <CookieBanner />
        </LanguageProvider>
      </SiteConfigProvider>
    </MotionConfig>
  );
}

export default App;
